export { SpeechRecognizer } from './SpeechRecognition'
export { SpeechSynthesizer, SynthesisGender } from './SpeechSynthesis'



// WEBPACK FOOTER //
// ./src/CognitiveServices/lib.ts